import $ from 'jquery';
import BaseView from '../core/baseView';
import * as eventEmitter from '../core/eventEmmiter';
import RemotePreloaderView from '../validation/remotePreloaderView';
import { reload } from '../validation/validation-controller';
import { get as t } from '../../home24/core/translation';

export default BaseView.extend({
    selectors: {
        taxId: '.js-tax-id input'
    },

    validationRules: {
        remoteTaxId: {
            url: '/default/validator/validateitaliantaxid',
            type: 'GET',
            data: {
                id: function () {
                    return $('.js-tax-id input:not(.myaccount-popup-holder .js-tax-id input)').val();
                }
            },
            beforeSend: function () {
                this.preloader = this.preloader || new RemotePreloaderView({
                    el: $('.js-tax-id input:not(.myaccount-popup-holder .js-tax-id input)')
                });
                this.preloader.show();
            },
            complete: function () {
                this.preloader.hide();
            }
        }
    },

    initialize: function () {
        if (this.$el.length) {
            eventEmitter
                .off('validationReload')
                .on('validationReload', this.addRulesToValidator, this);
            reload();
        }
    },

    destroy: function () {
        this.removeRules();
        BaseView.prototype.destroy.call(this);
    },

    addRulesToValidator: function () {
        this.$el.rules('add', {
            required: true,
            remote: this.validationRules.remoteTaxId,
            pattern: false,
            messages: {
                remote: t('ui.input.validation.tax_id.remote.error')
            }
        });
    },

    removeRules: function () {
        this.$el.rules('remove', {
            required: false,
            remote: false
        });
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/italianTaxId.js
 **/